'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { InView } from 'react-intersection-observer';
import { client } from '../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
import PostItem from './PostItem';

// Ten posts at a time, on scroll. This used to drain every page of every
// factiii in the query function before it rendered anything: a post cited by
// fifty taggers opened a spinner, made fifty round trips, and then mounted
// every PostItem at once.
//
// `posts.referencedPosts` rather than `posts.references`: the latter pages the
// taggers, and a page of ten taggers is ten posts or three hundred. This list
// is flat, so it pages the posts.
export default function ReferencedPostsModal(t0) {
  const $ = _c(26);
  const {
    postUuid,
    refCount,
    factiiiIds,
    onClose
  } = t0;
  let t1;
  let t2;
  if ($[0] !== factiiiIds || $[1] !== postUuid) {
    t1 = ["ReferencedPosts", postUuid, factiiiIds];
    t2 = t3 => {
      const {
        pageParam
      } = t3;
      return unwrapFromResult(client.posts.referencedPosts.query({
        postId: postUuid,
        factiiiIds,
        cursor: pageParam
      }));
    };
    $[0] = factiiiIds;
    $[1] = postUuid;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = factiiiIds.length > 0;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      initialPageParam: undefined as number | undefined,
      getNextPageParam: _temp,
      select: _temp4,
      enabled: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data,
    isLoading,
    isError,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage
  } = useInfiniteQuery(t4);
  let t5;
  if ($[8] !== data?.posts) {
    t5 = data?.posts ?? [];
    $[8] = data?.posts;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const posts = t5;
  const t6 = data ? data.total : refCount;
  let t7;
  if ($[10] !== t6) {
    t7 = <h2 className="text-xl font-semibold text-textPrimary">Referenced posts ({t6})</h2>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onClose || $[13] !== t7) {
    t8 = <ModalHeader closeHandler={onClose}>{t7}</ModalHeader>;
    $[12] = onClose;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== fetchNextPage || $[16] !== hasNextPage || $[17] !== isError || $[18] !== isFetchingNextPage || $[19] !== isLoading || $[20] !== posts) {
    t9 = <ModalContent>{isLoading ? <div className="flex justify-center py-8"><div className="size-8 animate-spin rounded-full border-b-2 border-primary" /></div> : isError ? <div className="py-8 text-center"><p className="text-textSecondary">Could not load the referenced posts. Close this and try again.</p></div> : posts.length ? <div className="space-y-3">{posts.map(_temp5)}{hasNextPage && <InView onChange={isVisible => isVisible && !isFetchingNextPage ? fetchNextPage() : undefined} className="flex justify-center py-4"><Loader2 className="animate-spin text-textSecondary" /></InView>}</div> : <div className="py-8 text-center"><p className="text-textSecondary">No posts referenced</p></div>}</ModalContent>;
    $[15] = fetchNextPage;
    $[16] = hasNextPage;
    $[17] = isError;
    $[18] = isFetchingNextPage;
    $[19] = isLoading;
    $[20] = posts;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onClose || $[23] !== t8 || $[24] !== t9) {
    t10 = <Modal closeHandler={onClose} maxWidth={800}>{t8}{t9}</Modal>;
    $[22] = onClose;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp5(post) {
  return <PostItem key={post.id} post={post} isFullLength={false} disableLink={false} isInView={true} />;
}
function _temp4(pages) {
  return {
    posts: pages.pages.flatMap(_temp3),
    total: pages.pages[0]?.total ?? 0
  };
}
function _temp3(page) {
  return page.posts.map(_temp2);
}
function _temp2(p) {
  return p.post;
}
function _temp(lastPage) {
  return lastPage.nextCursor ?? undefined;
}